// Get Environment

const ENV_CONFIG = {
  dev: {
    API_URL: process.env.REACT_APP_API_URL_DEV,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_DEV,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_DEV,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_DEV,
  },
  staging: {
    API_URL: process.env.REACT_APP_API_URL_STAGING,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_STAGING,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_STAGING,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_STAGING,
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL_PROD,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_PROD,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_PROD,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_PROD,
  },
};

const getEnvironment = () => {
  const server = process.env.REACT_APP_SERVER;

  if (!server) {
    throw new Error("Environment variables is not defined!");
  }

  return ENV_CONFIG[server];
};

const REACT_APP_ROZAR_PAY_KEY = process.env.REACT_APP_ROZAR_PAY_KEY;
const REACT_APP_ROZAR_PAY_SDK_URL = process.env.REACT_APP_ROZAR_PAY_SDK_URL;
const REACT_APP_PAYU_SDK_URL = process.env.REACT_APP_PAYU_SDK_URL;
const REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME = process.env.REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME;
const REACT_APP_RAMFINCORP_WEBSITE_URL = process.env.REACT_APP_RAMFINCORP_WEBSITE_URL;
const REACT_APP_ONBOARDING_JOURNEY_URL = process.env.REACT_APP_ONBOARDING_JOURNEY_URL;
const REACT_APP_CLEVERTAP_ACCOUNT_ID = process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID;
const REACT_APP_CREDEAU_AUTH_TOKEN = process.env.REACT_APP_CREDEAU_AUTH_TOKEN;
const REACT_APP_NEW_JOURNEY_URL = process.env.REACT_APP_NEW_JOURNEY_URL;
const IS_VIRTUAL_ACCOUNT_NUMBER_ENABLE = process.env.REACT_APP_IS_VIRTUAL_ACCOUNT_NUMBER_ENABLE === true || process.env.REACT_APP_IS_VIRTUAL_ACCOUNT_NUMBER_ENABLE === 'true';
const SIGNOZ_INGESTION_REGION = process.env.REACT_APP_SIGNOZ_INGESTION_REGION;
const SIGNOZ_INGESTION_KEY = process.env.REACT_APP_SIGNOZ_INGESTION_KEY;
const SIGNOZ_SERVICE_NAME = process.env.REACT_APP_SIGNOZ_SERVICE_NAME;
const SEND_SIGNOZ_TRACES = process.env.REACT_APP_SEND_SIGNOZ_TRACES || 0;
const SIGNOZ_DEPLOYMENT_ENV = process.env.REACT_APP_SIGNOZ_DEPLOYMENT_ENV;
const SIGNOZ_OTEL_TRACES_SAMPLER = process.env.REACT_APP_SIGNOZ_OTEL_TRACES_SAMPLER || 0.001;
const REACT_APP_CHAT_SUPPORT_API_URL = process.env.REACT_APP_CHAT_SUPPORT_API_URL;
const REACT_APP_CHAT_SUPPORT_FEEDBACK_URL = process.env.REACT_APP_CHAT_SUPPORT_FEEDBACK_URL;
const IS_CHAT_SUPPORT_ENABLED = process.env.REACT_APP_IS_CHAT_SUPPORT_ENABLED === true || process.env.REACT_APP_IS_CHAT_SUPPORT_ENABLED === 'true';

export { getEnvironment,
  REACT_APP_ROZAR_PAY_KEY,
  REACT_APP_ROZAR_PAY_SDK_URL,
  REACT_APP_PAYU_SDK_URL,
  REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME,
  REACT_APP_RAMFINCORP_WEBSITE_URL,
  REACT_APP_ONBOARDING_JOURNEY_URL,
  REACT_APP_CLEVERTAP_ACCOUNT_ID,
  REACT_APP_CREDEAU_AUTH_TOKEN,
  REACT_APP_NEW_JOURNEY_URL,
  IS_VIRTUAL_ACCOUNT_NUMBER_ENABLE,
  SIGNOZ_INGESTION_REGION,
  SIGNOZ_INGESTION_KEY,
  SIGNOZ_SERVICE_NAME,
  SEND_SIGNOZ_TRACES,
  SIGNOZ_DEPLOYMENT_ENV,
  SIGNOZ_OTEL_TRACES_SAMPLER,
  REACT_APP_CHAT_SUPPORT_API_URL,
  REACT_APP_CHAT_SUPPORT_FEEDBACK_URL,
  IS_CHAT_SUPPORT_ENABLED
};